import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, get } from "@green24/npm-javascript-utils";
import Interpret from "../../components/shared/Localization/Interpret";
import ButtonsConstructor from "../../components/shared/Input/Button/ButtonsConstructor";
import Keyboard from "../../components/Keyboard/Keyboard";
import { E_Keyboard_Type } from "../../models/constants/Enums_Keyboard";
import { sessionServices } from "../../services/session-services";
import { ErrorUtils } from "../../utils/ErrorUtils";
import { route } from "preact-router";
import { E_BoxRoute_Action, E_Route } from "../../models/constants/Enum_Routes";
import BoxTerminal from "../../components/shared/BoxTerminal";
import { E_Box_OpenMode } from "../../models/constants/Enums_Storage";
import MessageModal from "../../components/shared/Modal/MessageModal";
import { AppUtils } from "../../utils/AppUtils";
import withConfiguration from "../../components/shared/hoc/withConfiguration";
import { E_Configuration_DisplayMode } from "../../models/Models_Configuration";

class OpenBoxPinPage extends Component {
	constructor() {
		super();

		this.state = {
			pin: '',
			sending: false,
		}

		this._errorTimeout = null;
	}

	componentWillUnmount() {
		if(this._errorTimeout) {
			clearTimeout(this._errorTimeout);
			window.modal.close();
		}
	}

	_renderEnterPinPage() {
		const {boxAction, configuration} = this.props;
		const {pin, sending} = this.state;

		return (
			<BoxTerminal
				title={boxAction == E_BoxRoute_Action.RETRIEVE ? (configuration.mode ===  E_Configuration_DisplayMode.DELIVERY ? "box.open.end.delivery.title" : "box.open.end") : "box.open.repeated"}
				subtitle={boxAction == E_BoxRoute_Action.RETRIEVE ? (configuration.mode ===  E_Configuration_DisplayMode.DELIVERY ? "box.open.end.delivery.subtitle" : "box.open.end.subtitle") : "box.open.repeated.subtitle"}
				contentHeaderTitle={"pin.enter"}
				helperSlot={
					<p>
						<Interpret id={"pin.enter.help"}/>
					</p>}
				contentHeaderSlot={
					<div className={"input-value"}>
						<span>{Array(pin.length).fill('*').join('') || '‎'}</span>
						<hr/>
					</div>
				}
				contentSlot={
					<Keyboard
						view={E_Keyboard_Type.NUMERIC}
						valueDisplay={false}
						block={true}
						value={pin}
						onModify={v => this.setState({pin: pin + v})}
					/>
				}
				contentRightSlot={
					<ButtonsConstructor buttons={[
						{
							className: "open",
							icon: "lock-open",
							text: "box.open",
							action: () => this._openBox(),
							disabled: AppUtils.simulateBoxOpening ? false : (`${pin}`.length < 6 || sending),
							spinner: sending,
						}
					]}/>
				}
			/>
		)
	}

	render({className, style}) {
		return (
			<section className={combineClasses("open-box-pin-page", className)} style={style}>
				{this._renderEnterPinPage()}
			</section>
		);
	}

	_openBox() {
		clearTimeout(this._errorTimeout);

		const {boxAction} = this.props;
		const {pin} = this.state;

		this.setState({
			sending: true,
		});

		this._openingService(pin).then(data => {
			if(data.success === false && data.additionalPaymentAmount > 0) {
				route(E_Route.BOX_RENT_OVERTIME(boxAction, {
					physicalReference: get(data.session, "service.physicalReference"),
					sessionID: data.session.id,
					additionalPaymentAmount: data.additionalPaymentAmount,
				}));
			}
			else {
				route(E_Route.BOX_OPENING(boxAction, {
					timeout: data.openDelaySeconds,
					physicalReference: get(data.session, "service.physicalReference"),
				}));
			}
		}, (res) => {
			let error = ErrorUtils.getErrorFromResponse(res, {
				404: {
					icon: "lock",
					title: "box.open.error.invalidPin.title",
					message: "box.open.error.invalidPin.message",
					messageTranslated: false,
					retry: false,
				}
			});

			window.modal.open(
				<MessageModal
					icon={error.icon}
					title={error.title}
					message={error.message || "box.open.error.message"}
					messageTranslated={error.messageTranslated ?? !!error.message}
					titleTranslated={error.titleTranslated}
					actionButtons={[
						error.retry && {
							text: "retry",
							className: "confirm",
							action: () => {
								window.modal.close();

								this._openBox();
							},
						}
					]}
				/>,
				{
					accent: "error",
				},
			);

			this._errorTimeout = setTimeout(() => {
				window.modal.close();
			}, 60000);

			this.setState({
				sending: false,
			});
		});
	}

	get _openingService() {
		const {boxAction} = this.props;
		if(boxAction == E_BoxRoute_Action.OPEN) {
			return pin => sessionServices.openBoxByPin(pin, E_Box_OpenMode.OPEN_DELAYED, AppUtils.simulateBoxOpening);
		}

		return pin => sessionServices.completeSessionWithPin(pin, E_Box_OpenMode.OPEN_DELAYED, AppUtils.simulateBoxOpening);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			boxAction: PropTypes.oneOf(Object.values(E_BoxRoute_Action)),

			//withConfiguration
			configuration: PropTypes.object,
		}
	}

	static get stateTypes() {
		return {
			pin: PropTypes.string,
			sending: PropTypes.bool,
		}
	}

	static get defaultProps() {
		return {
			boxAction: E_BoxRoute_Action.OPEN,
		}
	}
}

export default withConfiguration(OpenBoxPinPage);
